module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-container",
    class: {
      'd-container--active': _vm.isDropDown
    }
  }, [_c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.setDropdownFromClick),
      expression: "setDropdownFromClick"
    }],
    ref: "d_parent",
    staticClass: "d-select__selected",
    on: {
      "click": _vm.setDropdown
    }
  }, [_c('h5', [_vm._v(_vm._s(_vm.selectedUser ? _vm.selectedUser.name : _vm.userName))]), _vm._v(" "), _c('svg', {
    staticClass: "tw-icon tw-icon-cheveron-selection",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    staticClass: "secondary",
    attrs: {
      "fill-rule": "evenodd",
      "d": "M8.7 9.7a1 1 0 1 1-1.4-1.4l4-4a1 1 0 0 1 1.4 0l4 4a1 1 0 1 1-1.4 1.4L12 6.42l-3.3 3.3zm6.6 4.6a1 1 0 0 1 1.4 1.4l-4 4a1 1 0 0 1-1.4 0l-4-4a1 1 0 0 1 1.4-1.4l3.3 3.29 3.3-3.3z"
    }
  })])]), _vm._v(" "), (_vm.isDropDown) ? _c('div', {
    ref: "d_child",
    staticClass: "d-select__dropdown",
    class: {
      'd-dropdown--animate': _vm.isPopperReady,
      'd-dropdown--show': _vm.isPopperDone
    }
  }, [_c('div', {
    staticClass: "d-select-input",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('span', {
    staticClass: "icon-search5"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    ref: "inputsearch",
    attrs: {
      "type": "search"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('ul', {
    ref: "d_list"
  }, _vm._l((_vm.usersQuery), function(user) {
    return _c('li', {
      ref: _vm.selectedUser && user.id === _vm.selectedUser.id ? 'selectedUser' : null,
      refInFor: true,
      class: {
        'user--is-selected': _vm.selectedUser && user.id === _vm.selectedUser.id
      },
      on: {
        "click": function($event) {
          return _vm.selectUser(user.id)
        }
      }
    }, [_c('p', [_vm._v(_vm._s(user.name))])])
  }), 0)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-227e34f8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/SelectUser.vue
// module id = 1802
// module chunks = 1